<template>
  <div>
    <Collapse v-model="value" simple style="border:0">
      <Panel name="6" hide-arrow style="margin: 20px 0;border:0">
        <FormTitle titleText="基本信息" />
        <Form
          :label-width="150"
          label-position="left"
          slot="content"
          style="margin: 30px 30px 0 30px"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工工号">
                <Input v-model="userinfoItem.empCode" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工姓名">
                <Input v-model="userinfoItem.userName" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工职位">
                <Input v-model="userinfoItem.positionName" disabled />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="月份">
                <Input v-model="userinfoItem.month" disabled />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>

      <Panel
        v-show="showKPI"
        name="1"
        hide-arrow
        style="margin: 20px 0;border:0"
      >
        <FormTitle titleText="绩效重点" />
        <div slot="content" style="margin-top: 20px;">
          <div>个人目标及绩效重点</div>
          <PersonalGoals ref="PersonalGoals"></PersonalGoals>
          <div>STI</div>
          <STIComponent ref="STIComponent"></STIComponent>
        </div>
      </Panel>
      <Panel
        v-show="showPlan"
        name="2"
        hide-arrow
        style="margin-bottom: 20px;border:0"
      >
        <FormTitle titleText="行为期望" />
        <div v-show="showPlan" style="margin-top: 30px" slot="content">
          <BehaviorExpectation ref="BehaviorExpectation"></BehaviorExpectation>
        </div>
      </Panel>
      <Panel
        v-show="showPlan"
        name="3"
        hide-arrow
        style="margin-bottom: 20px;border:0"
      >
        <FormTitle titleText="个人发展计划" />
        <div v-show="showPlan" style="margin-top: 30px" slot="content">
          <DevelopmentPlan ref="DevelopmentPlan"></DevelopmentPlan>
        </div>
      </Panel>
    </Collapse>
    <div class="btnRight" style="margin-top:30px">
      <Button
        type="primary"
        class="applyBtnRight"
        v-if="!isHistory"
        @click="importCG"
        >导入草稿</Button
      >
      <Button
        type="primary"
        class="applyBtnRight"
        v-if="!isHistory"
        @click="saveCG"
        >保存草稿</Button
      >
      <Button
        type="primary"
        class="applyBtnRight"
        v-if="!isHistory"
        @click="submit"
        >提交</Button
      >
      <Button type="primary" class="applyBtnRight" @click="returnApply"
        >返回</Button
      >
    </div>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
import STIComponent from "./components/STIComponent";
import DevelopmentPlan from "./components/DevelopmentPlan";
import PersonalGoals from "./components/PersonalGoals";
import BehaviorExpectation from "./components/BehaviorExpectation";
export default {
  components: {
    STIComponent,
    DevelopmentPlan,
    PersonalGoals,
    BehaviorExpectation
  },
  data() {
    return {
      date: new DateUtil(),
      sbumitDisabled: false,
      value: [1, 2, 3, 4, 5, 6],
      loading: false,
      showKPI: false,
      showPlan: false,
      isHistory: false,
      ach_info_id: "",
      userinfoItem: {}
    };
  },
  mounted() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    } else {
      this.getData();
    }
    this.getEmpInformation();
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      //草稿type 操作人
      this.$refs.cgTem.popShow(
        "AC01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      );
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      this.$refs.cgPop.popShow("AC01", {
        data1: this.data1,
        data3: this.data3,
        data5: this.data5,
        data6: this.data6,
        userinfoItem: this.userinfoItem
      });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      this.loading = true;
      var obj = JSON.parse(row.draftContent);
      this.data1 = obj.data1;
      this.data3 = obj.data3;
      this.data5 = obj.data5;
      this.data6 = obj.data6;
      this.userinfoItem = obj.userinfoItem;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    // 获取员工信息
    getEmpInformation() {
      axios
        .post("/ApplyAchStartYear/selectEmpInfo", {
          userId: JSON.parse(sessionStorage.getItem("userInfo")).userId
        })
        .then(res => {
          if (res && res != null) {
            this.userinfoItem = res.empInfo[0];
            this.userinfoItem.month = res.achMonth.month;
          }
        });
    },
    getData() {
      let obj = {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId
      };
      this.loading = true;
      axios.post("/ApplyAchStartYear/selectAchTypeData", obj).then(res => {
        this.loading = false;
        if (res) {
          this.data = res;
          if (this.data.length > 0) {
            this.ach_info_id = this.data[0].ach_info_id;
            this.data.forEach(item => {
              if (item.code == "work") {
                this.showWork = true;
              } else if (item.code == "kpi") {
                this.showKPI = true;
              } else if (item.code == "bsc") {
                this.showBSC = true;
              } else if (item.code == "plan") {
                this.showPlan = true;
              }
            });
          }
        } else {
          this.sbumitDisabled = true;
        }
      });
    },
    submit() {
      this.$Modal.confirm({
        title: this.$notice("submission"),
        content: "",
        onOk: () => {
          // this.handle()
        },
        onCancel: () => {}
      });
    },
    handle() {
      this.loading = true;
      axios.post("ApplyAchStartYear/selectAchStatus", {}).then(res2 => {
        if (res2) {
          let arr = [
            {
              stringData1: "AC01",
              type: "B31",
              objData1: {
                be_agent: 0,
                apply_user_id: JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).userId,
                apply_serialnumber: JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).serialnumber,
                apply_name: JSON.parse(
                  window.sessionStorage.getItem("userInfo")
                ).userName,
                ach_type_id: this.ach_info_id,
                apply_position_name: this.userinfoItem.positionName
                  ? this.userinfoItem.positionName
                  : null,
                apply_position: this.userinfoItem.positionCode
                  ? this.userinfoItem.positionCode
                  : null,
                ...this.userinfoItem
              }
            }
          ];
          axios.post("/process/execute", arr).then(res1 => {
            if (res1) {
              // 每一条数据 放一下instance id,用于审批获取
              this.data.forEach(item => {
                item.instanceId = res1[0];
                item.achTypeCode = item.code;
                item.achTypeName = item.name;
              });
              axios
                .post("/ApplyAchStartYear/savaAchTypeList", this.data)
                .then(res5 => {});
              this.data1.forEach(item => {
                item.achCode = "kpi";
                item.instanceId = res1[0];
              });
              this.data3.forEach(item => {
                item.achCode = "bsc";
                item.instanceId = res1[0];
              });
              this.data5.forEach(item => {
                item.achCode = "plan";
                item.instanceId = res1[0];
              });
              this.data6.forEach(item => {
                item.achCode = "work";
                item.instanceId = res1[0];
              });
              let ary = [this.data1, this.data3, this.data5, this.data6];
              axios
                .post("/ApplyAchStartYear/saveAchStartYear", ary)
                .then(res => {
                  if (res) {
                    this.$Message.info(this.$t("sbumit_Success"));
                    this.$router.push(
                      "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
                    );
                  }
                  this.loading = false;
                });
            }
          });
        } else {
          this.loading = false;
        }
      });
    },
    returnApply() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style lang="less" scoped>
// /deep/.ivu-table-cell{
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// /deep/.ivu-table-cell-tree {
//   margin-right: 10px;
// }
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ApplyAchStartYear.vue